import { createContext } from 'react';
import { OnClick } from '../../../common/model/EventModels';

export const AlertContext = createContext<OnClick | undefined>(undefined);
